import { requestGet, requestPut } from "../config/Api";

const base = "attachment/type";

export const getAttachmentTypes = () => requestGet(base);

export const updateAttachmentType = (id, data) => requestPut(`${base}/${id}`, data);